export function request(body) {
    return {
        type: 'CHANGE_PROMOTION_ORDER_REQUEST',
        body
    };
}

export function error(errors) {
    return {
        type: 'CHANGE_PROMOTION_ORDER_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'CHANGE_PROMOTION_ORDER_FINISH',
        data
    };
}
